import React from 'react';
import Modal from 'react-modal';
import { useT } from '../../../contexts/LocaleContext.jsx';

// `error` shows under the message (ENG-504), and `isBusy` disables Confirm
// while the action runs, so a caller can keep the dialog open until its
// request succeeds and say why when it doesn't.
const ConfirmationModal = ({ isOpen, onClose, onConfirm, title, message, confirmText, cancelText, isDangerous = false, confirmTestId, error = null, isBusy = false }) => {
  const t = useT();
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      contentLabel={title}
      className="modalContent"
      overlayClassName="modalOverlay"
    >
      <h2>{title}</h2>
      <p>{message}</p>
      {error && (
        <p className="modal-error" role="alert">{error}</p>
      )}
      <div className="button-group">
        <button
          type="button"
          onClick={onConfirm}
          disabled={isBusy}
          className={isDangerous ? 'btn-danger' : 'btn-save'}
          data-testid={confirmTestId}
        >
          {confirmText ?? t('common.actions.confirm')}
        </button>
        <button type="button" onClick={onClose} className="btn-cancel">
          {cancelText ?? t('common.actions.cancel')}
        </button>
      </div>
    </Modal>
  );
};

export default ConfirmationModal;
